import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';

function ObservationFormDialog({
  open,
  onClose,
  onSave,
  editForm,
  setEditForm,
  indicators,
  title,
  saveButtonText,
}) {
  const { t } = useTranslation();
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label={t('observations.date')}
            type="date"
            fullWidth
            value={editForm.date}
            onChange={(e) => setEditForm({ ...editForm, date: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <FormControl fullWidth>
            <InputLabel>{t('observations.indicatorId')}</InputLabel>
            <Select
              value={editForm.indicator_id}
              label={t('observations.indicatorId')}
              onChange={(e) => setEditForm({ ...editForm, indicator_id: e.target.value })}
            >
              {indicators.map((ind) => (
                <MenuItem key={ind.indicator_id} value={ind.indicator_id}>
                  {ind.indicator_id} - {ind.indicator_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label={t('observations.value')}
            type="number"
            fullWidth
            value={editForm.value}
            onChange={(e) => setEditForm({ ...editForm, value: e.target.value })}
            slotProps={{ htmlInput: { step: "0.01" } }}
          />
          <TextField
            label={t('observations.notes')}
            fullWidth
            multiline
            rows={3}
            value={editForm.notes}
            onChange={(e) => setEditForm({ ...editForm, notes: e.target.value })}
            placeholder={t('observations.addNotes')}
          />
          <TextField
            label={t('observations.sourceUrl')}
            fullWidth
            value={editForm.source_url}
            onChange={(e) => setEditForm({ ...editForm, source_url: e.target.value })}
            placeholder={t('observations.addSourceUrl')}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('observations.cancel')}</Button>
        <Button onClick={onSave} variant="contained" color="primary">
          {saveButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ObservationFormDialog;
